<template>
<section class="item-details-section">
    <div>
        <span class="text-semibold">Type: </span>
        <span>{{ earningType.type_pretty }}</span>
    </div>

    <div>
        <span class="text-semibold">Designation: </span>
        <span>{{ earningType.designation_pretty || '-' }}</span>
    </div>

    <div>
        <span class="text-semibold">Sort Priority: </span>
        <span>{{ earningType.sort_priority }}</span>
    </div>

    <div>
        <span class="text-semibold">Has Tip Credit Claimed:</span>
        <span> {{ earningType.has_tip_credit_claimed ? 'Yes' : 'No' }}</span>
    </div>

    <div>
        <span class="text-semibold">Is Tips: </span>
        <span>{{ earningType.is_tips ? 'Yes' : 'No' }}</span>
    </div>

    <div>
        <span class="text-semibold">Is Cash Tips: </span>
        <span>{{ earningType.is_cash_tips ? 'Yes' : 'No' }}</span>
    </div>

    <div>
        <span class="text-semibold">Is Work Suffered: </span>
        <span>{{ earningType.is_work_suffered ? 'Yes' : 'No' }}</span>
    </div>

    <div>
        <span class="text-semibold">Is Virtual (e.g. PUCC): </span>
        <span> {{ earningType.is_virtual ? 'Yes' : 'No' }}</span>
    </div>

    <div>
        <span class="text-semibold">Symmetry Wage Type: </span>
        <span>{{ earningType.symmetry_wage_type_pretty || '-' }}</span>
    </div>

    <div v-if="earningType.is_virtual">
        <span class="text-semibold">Symmetry Imputed Income Type: </span>
        <span>{{ earningType.imputed_income_type_pretty || '-' }}</span>
    </div>

    <div v-if="earningType.symmetry_wage_type === 'Regular' && !earningType.is_virtual">
        <span class="text-semibold">Allow Supplemental Treatment: </span>
        <span>{{ earningType.symmetry_wage_type_supplemental_treatment ? 'Yes' : 'No' }}</span>
    </div>

    <div>
        <span class="text-semibold">Allow Multiple Per Company: </span>
        <span>{{ earningType.allow_multiple_per_company ? 'Yes' : 'No' }}</span>
    </div>

    <div>
        <span class="text-semibold">W2 Box: </span>
        <span>{{ earningType.w2_box != null ? `Box ${earningType.w2_box}` : '-' }}</span>
    </div>

    <div>
        <span class="text-semibold">W2 Code: </span>
        <span>{{ earningType.w2_code || '-' }}</span>
    </div>

    <!--
    <div>
        <span class="text-semibold">Fields to Customize: </span>
        <span>{{ earningType.fields_to_customize && earningType.fields_to_customize.length ? earningType.fields_to_customize.join(', ') : '-' }}</span>
    </div>
    -->
</section>
</template>

<script>
export default {
    props: ['earningType', ],
}
</script>
